import React from 'react';
import SearchMoveForm from 'components/forms/SearchMoveForm';
import {Trans, useTranslation} from 'react-i18next';
import SearchResults from 'components/SearchResults';
import Button from 'components/Button';
import Box from '@mui/material/Box';
import {SearchObjectType, useSearchApi} from 'features/layout/DialogRoutes/dialogs/search/hooks';

type SearchSSLKeysFormProps = {
   onClose?: () => void;
};

const SearchSSLKeysForm = ({onClose}: SearchSSLKeysFormProps) => {
   const {t} = useTranslation();

   const {results, search, exportResults} = useSearchApi(
      SearchObjectType.SSL,
      t('SSL Certificate Export'),
      t('Selected SSL certs successfully exported')
   );
   return (
      <>
         <SearchMoveForm
            searchFieldsLabel={t('Include all SSL certificates keys or find certificates with:')}
            searchResult={
               results ? (
                  <Trans t={t}>{{itemsCount: results.length}} Certificates found.</Trans>
               ) : null
            }
            onSubmit={search}
         />
         <SearchResults
            label={t('Double-click to edit a certificate.')}
            data={results}
            onExport={exportResults}
         />
         {onClose && (
            <Box textAlign={'center'}>
               <Button onClick={onClose}>{t('Close')}</Button>
            </Box>
         )}
      </>
   );
};

export default SearchSSLKeysForm;
